import Card from 'components/card';
import { AuthContext } from 'contexts/AuthContext';
import { useFormKeyboardSubmit } from 'pages/Hooks/useStepperKeyboardNavigation';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import CreateAccountant from './Steps/AccountantInfo';
import accountantService from 'ApiService/Admin/accountantService';
import ConfirmationModal from 'pages/Common/ConfirmationModal';

const Index = () => {
  const [accountantData, setAccountantData] = useState({
    accountantName: '',
    accountantEmail: '',
    accountantPassword: '',
    contactNumber: '',
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(true);
  const router = useNavigate();
  const { state } = useContext(AuthContext);
  const selectedBranch = state?.selectedBranch || '';

  const handleSubmit = async () => {
    if (
      !accountantData.accountantName &&
      !accountantData.accountantEmail &&
      !accountantData.accountantPassword &&
      !accountantData.contactNumber
    ) {
      toast.error('All fields are required.');
    }
    setIsModalOpen(true);
  };

  const confirmCreation = async () => {
    setIsModalOpen(false);
    setLoading(true);
    try {
      const trimmedData = {
        accountantName: accountantData.accountantName
          ?.trim()
          .replace(/\s+/g, ' '),
        accountantEmail: accountantData.accountantEmail
          ?.trim()
          .replace(/\s+/g, ' '),
        accountantPassword: accountantData.accountantPassword
          ?.trim()
          .replace(/\s+/g, ' '),

        contactNumber: accountantData.contactNumber
          ?.trim()
          .replace(/\s+/g, ' '),
      };
      const response = await accountantService.createAccountant({
        ...trimmedData,
        selectedBranch,
      });
      if (response.data.success) {
        setAccountantData({
          accountantName: '',
          accountantEmail: '',
          accountantPassword: '',
          contactNumber: '',
        });
        toast.success(response?.data?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  useFormKeyboardSubmit(handleSubmit, disable, loading);

  return (
    <div className="mt-3 h-full w-full">
      <div className="h-[350px] w-full rounded-[20px] bg-gradient-to-br from-brand-400 to-brand-600 md:h-[390px]" />
      <div className="w-md:2/3 mx-auto h-full w-5/6 md:px-3 3xl:w-7/12">
        <Card extra=" -mt-[280px] w-full md:-mt-[240px] md:px-[70px] h-full mx-auto pb-3">
          <div className="rounded-[20px]">
            <CreateAccountant
              setAccountantData={setAccountantData}
              accountantData={accountantData}
              disable={disable}
              setDisable={setDisable}
            />
          </div>
          <div className="mt-4 flex flex-col justify-end px-3 pt-2 md:flex-row md:px-8">
            <button
              disabled={disable}
              onClick={handleSubmit}
              className="linear cursor-pointer rounded-xl bg-brand-900 px-16 py-2 font-medium text-white transition duration-200 hover:bg-brand-800 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90 md:ml-2"
            >
              {loading ? 'Loading..' : 'Submit'}
            </button>
          </div>
        </Card>
      </div>
      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={confirmCreation}
        title="Create Accountant Confirmation"
        message={`Are you sure you want to create ${accountantData.accountantName} as an accountant user?`}
        confirmText="Yes, Create"
        cancelText="Cancel"
        icon="info"
      />
    </div>
  );
};

export default Index;
